module.exports = __webpack_public_path__ + "static/media/icon-play.a8e7492f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-play.svg
// module id = 383
// module chunks = 0